/** Whether another page of expenses should be requested. */
export function shouldLoadAnotherExpensePage(
  loadedCount: number,
  totalCount: number,
  batchLength: number,
  pageSize: number,
): boolean {
  if (batchLength < pageSize) return false;
  return loadedCount < totalCount;
}
